import classNames from 'classnames';
import BButton from 'components/common/BButton';
import BImage from 'components/common/BImage';
import ResponsiveCarousel from 'components/common/ResponsiveCarousel';
import { FunctionComponent } from 'react';

interface VehicleDetailCarouselProps {
  images: string[];
  vehicleName: string;
  onImageClick: () => void;
}

const VehicleDetailCarousel: FunctionComponent<VehicleDetailCarouselProps> = ({
  images,
  vehicleName,
  onImageClick,
}) => {
  const shownImages = images.length < 5 ? [images[0]] : images.slice(0, 5);

  return (
    <>
      <div className="block md:hidden">
        <ResponsiveCarousel slidesPerView={1} pagination={{ type: 'fraction' }}>
          {images.map((image, idx) => (
            <BButton
              className="h-[75vw] w-full"
              onClick={onImageClick}
              key={image}
              priority="none"
            >
              <BImage
                src={image}
                alt={`${vehicleName}-${idx}`}
                layout="fill"
                objectFit="cover"
                priority={idx === 0}
              />
            </BButton>
          ))}
        </ResponsiveCarousel>
      </div>
      <div className="hidden md:block">
        <div className="grid h-[50vw] grid-cols-4 grid-rows-2 items-center gap-2 md:h-80 lg:h-[27rem] xl:h-[33rem] 2xl:h-[35rem]">
          {shownImages.length === 1 ? (
            <BButton
              className="relative col-span-4 row-span-2 h-full cursor-pointer"
              onClick={onImageClick}
              priority="none"
            >
              <BImage
                src={images[0]}
                alt={`${vehicleName}-${0}`}
                layout="fill"
                objectFit="cover"
                priority
              />
            </BButton>
          ) : (
            shownImages.map((image, idx) => (
              <BButton
                key={`image-carousel-${idx}`}
                className={classNames('relative h-full cursor-pointer', {
                  'col-span-2 row-span-2': idx === 0,
                  'col-span-1 row-span-1': idx !== 0,
                })}
                priority="none"
                onClick={onImageClick}
              >
                <BImage
                  src={image}
                  alt={`${vehicleName}-${idx}`}
                  layout="fill"
                  objectFit="cover"
                  priority={idx < 5}
                />
              </BButton>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default VehicleDetailCarousel;
